const EasterEgg = () => {
  return <div data-kakaotalk-password="0059043" />;
};

export default EasterEgg;
